import React, { useCallback, useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import "../UnitConverter.scss";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import { formatWeight } from "helpers/commonHelpers";
import { ConversionUnits, options } from "./options";

type ConverterInputProps = {
  value: number;
  unit: ConversionUnits;
};

function ConverterInput(props: ConverterInputProps) {
  const { value, unit } = props;
  const methods = useForm();
  const [convertValue, setConvertValue] = useState<any>(null);

  const setConvertedValue = useCallback(
    (selectedUnit: ConversionUnits) => {
      const selectedUnitOption = options[unit]?.find((val) => val.value === selectedUnit);
      if (selectedUnitOption) {
        setConvertValue(Number(selectedUnitOption.convert(value).toFixed(5)));
      }
    },
    [unit, value],
  );

  useEffect(() => {
    if (options[unit]) {
      setConvertedValue(options[unit][0].value);
    }
  }, []);

  useEffect(() => {
    const initialSelectedUnit: ConversionUnits = methods.getValues("units");
    setConvertedValue(initialSelectedUnit);
  }, [setConvertedValue]);

  const handleUnitChange = (obj: any) => {
    setConvertedValue(obj.value as ConversionUnits);
  };

  return options[unit] ? (
    <FormProvider {...methods}>
      <div className="unit-converter-input">
        <p>{`${formatWeight(convertValue?.toFixed(2))}`}</p>
        <div className="dropdown-div ml-2 w-90">
          <Dropdown
            className="schedule-dropdown"
            defaultValue={options[unit][0].value}
            options={options[unit]}
            onChange={(value: any) => {
              handleUnitChange(value);
            }}
          />
        </div>
      </div>
    </FormProvider>
  ) : (
    <FormattedMessage id="components.organisms.unitConverter.notSupported" defaultMessage="Unit not supported" />
  );
}

export default ConverterInput;
